import { Card } from '../../../components/ui/card';
import { Receipt, Hourglass, ClipboardCheck, CheckCircle2, AlertTriangle, IndianRupee } from 'lucide-react';

const inr = n => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;

export const CnKpis = ({ t, onPick }) => {
  const cards = [
    { k: 'all', label: 'All credit notes', value: t.all, sub: inr(t.amount), icon: Receipt, tint: 'bg-slate-100 text-slate-700' },
    { k: 'training', label: 'Training concern', value: t.training, sub: inr(t.training_amount), icon: IndianRupee, tint: 'bg-violet-50 text-violet-700' },
    { k: 'awaiting_trainer', label: 'Awaiting trainer', value: t.awaiting_trainer, icon: Hourglass, tint: 'bg-amber-50 text-amber-700', pick: true },
    { k: 'awaiting_review', label: 'Awaiting review', value: t.awaiting_review, icon: ClipboardCheck, tint: 'bg-blue-50 text-blue-700', pick: true },
    { k: 'closed', label: 'Closed', value: t.closed, icon: CheckCircle2, tint: 'bg-emerald-50 text-emerald-700', pick: true },
    { k: 'flagged', label: 'Flagged', value: t.flagged, sub: t.unlinked ? `${t.unlinked} trainer not linked` : 'enrolment / trainer check', icon: AlertTriangle, tint: 'bg-rose-50 text-rose-700', pick: true },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-3" data-testid="cn-kpis">
      {cards.map(c => (
        <Card key={c.k} onClick={() => c.pick && onPick(c.k)} className={`p-4 ${c.pick ? 'cursor-pointer hover:border-slate-300 transition-colors' : ''}`} data-testid={`cn-kpi-${c.k}`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${c.tint}`}><c.icon className="w-4 h-4" /></div>
          <div className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">{c.label}</div>
          <div className="text-xl font-bold mt-0.5 text-slate-900">{c.value}</div>
          {c.sub && <div className="text-[11px] text-slate-500">{c.sub}</div>}
        </Card>
      ))}
    </div>
  );
};
